.link {
  font-size: 13px;
  font-weight: 300;
  line-height: 18px;
  white-space: nowrap;
}
